import setupLocatorUI from '@locator/runtime';
import { StyledEngineProvider } from '@mui/material/styles';
import ReactDOM from 'react-dom/client';

import App from './App';
import configureStore from './redux/store';

const { store } = configureStore();

const rootEl = document.getElementById('root');

if (process.env.NODE_ENV === 'development') {
  const params = new URLSearchParams(window.location.search);
  const locatorEnabled =
    process.env.REACT_APP_ENABLE_LOCATOR === 'true' || params.get('locator') === '1';
  if (locatorEnabled) {
    setupLocatorUI();
  }
}

if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <StyledEngineProvider injectFirst>
      <App store={store} />
    </StyledEngineProvider>,
  );
}

if (module.hot) {
  module.hot.accept('./App', () => {
     
    const NextApp = require('./App').default;
    if (rootEl) {
      ReactDOM.createRoot(rootEl).render(
        <StyledEngineProvider injectFirst>
          <NextApp store={store} />
        </StyledEngineProvider>,
      );
    }
  });
}
